import { render, staticRenderFns } from "./DetalheComponent4.vue?vue&type=template&id=85cd9252"
import script from "./DetalheComponent4.vue?vue&type=script&lang=js"
export * from "./DetalheComponent4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports